import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { TextLinkCaret as TextLinkCaret$1 } from '@vds/core';
import styles from './text-link-caret.module.scss.js';
import RightCaretRegular from '../../icons/component-icons/right-caret-regular/index.js';
import LeftCaretRegular from '../../icons/component-icons/left-caret-regular/index.js';

const TextLinkCaret = (props) => {
    const { surface, bold = true, iconPosition = 'right', disabled, dataLoc, href, role, ariaLabel, children, tabIndex, size = 'small', onKeyDown, onClick, 'aria-label': arialabel, 'data-testid': testId = 'text-link-caret' } = props, rest = __rest(props, ["surface", "bold", "iconPosition", "disabled", "dataLoc", "href", "role", "ariaLabel", "children", "tabIndex", "size", "onKeyDown", "onClick", 'aria-label', 'data-testid']);
    const linkStyles = [
        styles.textLinkCaret,
        styles[iconPosition],
        styles[size],
        styles[surface === null || surface === void 0 ? void 0 : surface.toLowerCase()],
    ];
    const contentWrapperStyles = [styles.contentWrapper];
    const iconWrapperStyles = [
        styles.iconWrapper,
        styles[iconPosition],
        styles[size],
    ];
    const inlineWrapperStyles = [styles.inlineWrapper];
    const childWrapperStyles = [styles.childWrapper];
    const textWrapperStyles = [styles.textWrapper];
    const coreTextLinkCaretWrapperStyles = [
        styles.coreTextLinkWrapper,
        styles[size],
        styles[iconPosition],
    ];
    if (disabled)
        linkStyles.push(styles.disabled);
    const _calculateRole = () => {
        if (role)
            return role;
        if (href)
            return 'link';
        if (onClick)
            return 'button';
    };
    const _calculateAriaLabel = () => {
        if (ariaLabel || arialabel)
            return ariaLabel || arialabel;
        if (children && typeof children === 'string')
            return children;
        return 'Text Link Caret';
    };
    const _onKeyDown = (e) => {
        if (onKeyDown)
            onKeyDown(e);
        if ((e.key === 'Enter' || e.key === ' ') && onClick) {
            e.target.click();
        }
    };
    const _formatChildren = (childArray) => {
        let textWithoutCaret = '';
        childArray.forEach((item, index) => {
            if (index !== childArray.length - 1) {
                textWithoutCaret += `${item} `;
            }
        });
        return textWithoutCaret;
    };
    const checkForNode = () => {
        const lastIndex = children.length - 1; // number of last index in child array
        const lastChild = children[lastIndex]; // last child in child array
        const isNode = typeof children[lastIndex] !== 'string'; // if last child is node
        const isString = typeof children === 'string'; // if children are a string
        const firstNodes = [];
        if (children.length === undefined || children.length <= 1)
            return { childArray: [], textWithCaret: children }; // if only one child put with caret and return
        if (isNode || !isString) {
            // if the last child is node or mixture put last with the caret
            children.forEach((child, index) => {
                // add all children to first nodes except the last one
                if (index !== lastIndex) {
                    firstNodes[index] = child;
                }
            });
            return { childArray: firstNodes, textWithCaret: lastChild };
        }
        // To account for trailing space in the last word breaking the styling of caretand filter our all extra spaces in the textLink
        const trimmed = children.trim();
        // If all children are "strings", put last word with caret
        const childArray = trimmed.split(' ');
        const textWithCaret = childArray[childArray.length - 1];
        return {
            childArray: _formatChildren(childArray),
            textWithCaret,
        };
    };
    const childArray = children ? checkForNode().childArray : [];
    const textWithCaret = children ? checkForNode().textWithCaret : '';
    const textLinkCaretSizing = () => {
        switch (size) {
            case 'medium':
                return 16;
            case 'large':
                return 20;
            case 'small':
            default:
                return 12;
        }
    };
    return bold ? (jsx("div", { className: coreTextLinkCaretWrapperStyles.join(' '), children: jsx(TextLinkCaret$1, Object.assign({}, props)) })) : (jsx("a", Object.assign({}, rest, { className: linkStyles.join(' '), "data-testid": testId, "data-loc": dataLoc, href: href, role: _calculateRole(), "aria-disabled": disabled, "aria-label": _calculateAriaLabel(), tabIndex: disabled ? -1 : tabIndex || 0, onKeyDown: _onKeyDown, onClick: onClick, children: jsx("div", { className: contentWrapperStyles.join(' '), tabIndex: -1, "aria-hidden": true, children: jsxs("div", { className: inlineWrapperStyles.join(' '), role: "text", children: [iconPosition === 'left' && (jsx("div", { className: iconWrapperStyles.join(' '), tabIndex: -1, "aria-hidden": true, children: jsx(LeftCaretRegular, { ariaHidden: true, tabIndex: -1, "aria-label": `${iconPosition}-caret-regular icon`, size: textLinkCaretSizing(), surface: surface }) })), jsxs("div", { className: childWrapperStyles.join(' '), tabIndex: -1, "aria-hidden": true, children: [childArray, jsxs("div", { className: textWrapperStyles.join(' '), children: [textWithCaret, iconPosition === 'right' && (jsx("div", { className: iconWrapperStyles.join(' '), tabIndex: -1, "aria-hidden": true, children: jsx(RightCaretRegular, { ariaHidden: true, tabIndex: -1, "aria-label": `${iconPosition}-caret-regular icon`, size: textLinkCaretSizing(), surface: surface }) }))] })] })] }) }) })));
};

export { TextLinkCaret as default };
